import { useParams } from "react-router-dom";
import { Helmet } from "react-helmet";
import Dashboard from "../../layouts/Dashboard";
import { SHOW_MEMBER_PROFILE_FEATURE_FLAG } from "../../context/features/features.utils";
import { useExperiment } from "../../hooks/useExperiment";
import UserProfile from "./UserProfile";
import { UserProvider } from "./hooks/useUserContext";

type UserParams = {
  userUuid: string;
};

export default function App() {
  const { userUuid } = useParams<UserParams>();
  const { useExperimentValue } = useExperiment();

  /**
   * Setting the default value to `true` to prevent false redirect.
   * When the feature is disabled, the user will still be redirected.
   */
  const isMemberProfilePageEnabled = useExperimentValue(
    SHOW_MEMBER_PROFILE_FEATURE_FLAG,
    true,
  ) as boolean;

  if (!isMemberProfilePageEnabled) {
    window.location.href = `/members/view/${userUuid}`;
  }

  return (
    <>
      <Helmet>
        <title>User Profile</title>
      </Helmet>
      <Dashboard scrollableContent disableContentPadding>
        <UserProvider>
          <UserProfile userUuid={userUuid} />
        </UserProvider>
      </Dashboard>
    </>
  );
}
